import type { UploadedAttachment } from "./types";

/**
 * POST a single file to the Next.js proxy, which forwards to the Laravel
 * /api/sola/uploads endpoint. Resolves with the structured upload metadata.
 */
export async function uploadAttachment(
  file: File,
  options: { conversationId?: string | null; signal?: AbortSignal } = {}
): Promise<UploadedAttachment> {
  const form = new FormData();
  form.append("file", file, file.name);
  if (options.conversationId) {
    form.append("conversation_id", options.conversationId);
  }

  const res = await fetch("/api/sola/uploads", {
    method: "POST",
    body: form,
    signal: options.signal,
    credentials: "same-origin",
  });

  if (!res.ok) {
    let detail = "";
    try {
      const body = await res.json();
      detail = body?.message || body?.errors?.file?.[0] || JSON.stringify(body);
    } catch {
      detail = await res.text().catch(() => "");
    }
    throw new Error(detail || `Upload failed with status ${res.status}`);
  }

  return (await res.json()) as UploadedAttachment;
}
